var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_471",
    "data-name": "Rectangle 471",
    width: 21.214,
    height: 23.026,
    fill: "#2341d0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "parrain",
    transform: "translate(-729 -680)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_41",
    "data-name": "Ellipse 41",
    cx: 17,
    cy: 17,
    r: 17,
    transform: "translate(729 680)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "parrain-icon",
    transform: "translate(735.613 685.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_11400",
    "data-name": "Groupe 11400",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_676",
    "data-name": "Trac\\xE9 676",
    d: "M4.795,10.156,2.877,9.485a.4.4,0,0,0-.507.243l-2.346,6.7a.4.4,0,0,0,.243.507l1.918.671a.4.4,0,0,0,.507-.243l2.346-6.7A.4.4,0,0,0,4.795,10.156Zm.634.993L3.3,17.216l1.02.74C6.5,20.1,6.845,20.55,8.964,22.669c.893.893,2.019-.111,1.67-.6L8.927,20.445a.26.26,0,0,1-.005-.37.266.266,0,0,1,.375-.005l1.934,1.855.211.2.2.18c.592.534,1.828-.534,1.279-1.073l-1.934-1.855a.265.265,0,0,1,.37-.38l1.934,1.855c.417.4,1.025-.042,1.237-.454a.574.574,0,0,0-.074-.724L12.52,17.813a.265.265,0,0,1,.37-.38l1.934,1.855.016.016c.576.576,1.649-.6,1.221-1.03L13.371,15.6c-.83-.824-1.559-1.078-2.447-.476a3.027,3.027,0,0,1-3.192.359,1.744,1.744,0,0,1-.919-1.115.908.908,0,0,1,.454-1l2.214-1.316Zm12.423,5.892L15.786,11.15c-1.237.222-5.179.745-5.517,1.03a.322.322,0,0,1-.085.063l-2.658,1.58c-.343.2-.222.571-.005.83a1.586,1.586,0,0,0,.454.365,2.514,2.514,0,0,0,2.642-.333c1.115-.756,2.1-.465,3.112.539l2.616,2.6Zm.486-7.556-1.918.671a.4.4,0,0,0-.243.507l2.24,6.4c.085.217.1.417.306.518a.385.385,0,0,0,.306.016l1.918-.671a.4.4,0,0,0,.243-.507l-2.346-6.7A.4.4,0,0,0,18.338,9.485Zm-6.526-7.63L10.608,0,9.413,1.849a.262.262,0,0,1-.159.122L7.12,2.542,8.51,4.254a.255.255,0,0,1,.063.185L8.452,6.648l2.066-.8a.262.262,0,0,1,.19,0l2.061.8-.116-2.209a.254.254,0,0,1,.058-.18l1.4-1.717-2.135-.571A.274.274,0,0,1,11.812,1.855ZM19.1,4.169l-.539-.83-.534.819a.248.248,0,0,1-.159.122l-.956.254.618.761a.255.255,0,0,1,.063.185l-.053.988.925-.354a.262.262,0,0,1,.19,0l.925.354-.053-.988a.254.254,0,0,1,.058-.18l.624-.766-.956-.254a.264.264,0,0,1-.153-.111m-15.905,0-.539-.83-.534.819a.248.248,0,0,1-.159.122l-.956.254.618.766a.255.255,0,0,1,.063.185l-.053.988.925-.354a.262.262,0,0,1,.19,0l.925.354-.053-.988a.254.254,0,0,1,.058-.18L4.3,4.539l-.956-.254a.28.28,0,0,1-.153-.116",
    transform: "translate(0)",
    fill: "#2341d0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParrain);
export default __webpack_public_path__ + "static/media/parrain.bac51ac63e5047429acf551083dde6ef.svg";
export { ForwardRef as ReactComponent };